import { render, staticRenderFns } from "./SwitchChildInfoModal.vue?vue&type=template&id=f4193712&scoped=true&"
import script from "./SwitchChildInfoModal.vue?vue&type=script&lang=js&"
export * from "./SwitchChildInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4193712",
  null
  
)

export default component.exports